import {Component, OnInit, inject, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {UtilService} from '../../services/util.service';
import {DataService} from 'src/app/services/data.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
  standalone: false
})

export class FaqComponent implements OnInit {
  private _destroyRef: DestroyRef = inject(DestroyRef);
  private _utilService: UtilService = inject(UtilService);
  private _dataService: DataService = inject(DataService);

  public faqs: any;
  private _phoneNumber: string = '';
  private _weekdaysupport: string = '';

  public ngOnInit(): void {
    this._phoneNumber = this._dataService.PhoneNumber;
    this._weekdaysupport = this._dataService.WeekdayHours;
    this._getFaqs();
  }

  private _getFaqs() {
    this._utilService.getFaqs()
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((response) => {
        this._replaceSupportInformation(response);
      });
  }

  private _replaceSupportInformation(response: any): void {
    const replaceJson = [
      {targetText: '{phoneNumber}', value: this._phoneNumber},
      {targetText: '{supportHours}', value: this._weekdaysupport}
    ];

    for (let index = 0; index < replaceJson.length; index++) {
      const element = replaceJson[index];
      response = replaceTextWithDynamicValue(response, element.targetText, element.value);
    }
    this.faqs = response;
  }
}

function replaceTextWithDynamicValue(obj: any, targetText: string, dynamicValue: any): any {
  if (typeof obj === 'object' && obj !== null) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        obj[key] = replaceTextWithDynamicValue(obj[key], targetText, dynamicValue);
      }
    }
  } else if (typeof obj === 'string') {
    obj = obj.replace(new RegExp(targetText, 'g'), dynamicValue);
  }

  return obj;
}
